import React from 'react';

import b_ from 'b_';

import {Button} from 'client/common/components/lego';

import {createLink} from 'client/common/utils/window';
import I18N from 'assets/i18n/brandlift-project';

import EmptyListIcon from './icons/empty-list.svg';

import './empty-state.css';

const i18n = I18N.list.surveyList;
const b = b_.with('survey-list');

export default function EmptyState() {
    return (
        <div className={b('empty-state-wrapper')}>
            <h2 className={b('title')}>{i18n.title}</h2>
            <img className={b('empty-state-image')} src={EmptyListIcon} />
            <span className={b('empty-state-text')}>{i18n.emptyState.text}</span>
            <a className={b('empty-state-button-wrapper')} href={createLink('/quicksurvey')}>
                <Button className={b('empty-state-button')} view='action' size='m'>
                    {i18n.emptyState.buttonLabel}
                </Button>
            </a>
        </div>
    );
}
